<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <div class="wrapper">

    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="'예문을 검색 합니다.'"
                        [keyHistoryKeyword]="historyKeySearch"
                        [keyHistoryView]="historyKeyView"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">

          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <app-example-cat-index [treeList]="treeList"
                                       [selectedPostposition]="selectedPostposition"
                                       (selectCat)="onSelectCat($event)"
                                       (select)="onSelectPostposition($event)"></app-example-cat-index>

                <div #extBody
                     class="book-page-group">

                  <div class="page-box">
                    <div #listContainer
                         (scroll)="onScroll($event)"
                         class="page-contents scroll-effect over-y">

                      <article class="result-list-layout1"
                               [class.empty]="ll?.getTotalCount() === 0">
                        <div class="list-wrap" #innerScroll>
                          <ul role="listbox">
                            <li *ngFor="let example of ll?.getList()"
                                id="example-{{ example.id }}"
                                [class.selected]="curDetail?.id === example.id"
                                [attr.aria-selected]="curDetail?.id === example.id"
                                role="option"
                                (click)="onSelectExample(example)">
                              <app-example-list-item [example]="example"
                                                     [manualPlay]="true"
                                                     (play)="onSelectExample(example, 'force')"></app-example-list-item>
                            </li>

                            <li class="reload-icon" *ngIf="ll?.getList() && !ll?.IsLastPage()">
                              <img #reload src="assets/img/loading_icon.gif">
                            </li>

                            <li class="no-result" *ngIf="ll?.getTotalCount() === 0">
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">예문이 없습니다.</div>
                            </li>

                          </ul>
                        </div>
                      </article>

                    </div>

                  </div>
                  <div class="page-box">

                    <app-example-detail *ngIf="curDetail"
                                        [example]="curDetail"
                                        [exampleSJ]="curDetailSJ"
                                        [sendingBookmark]="sendingBookmark"
                                        (toggleBookmark)="onToggleBookmark($event)">
                    </app-example-detail>

                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>

              </div>

            </div>

          </article>

        </div>

      </div>

    </section>

  </div>

  <app-common-popups></app-common-popups>

</div>
